import { Badge, UncontrolledTooltip } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { API_BASE_URL } from "../../api/api";

export const getProductColumns = (columnHelper, navigate, handleToggleStatus,role) => [
  columnHelper.display({
    id: "image",
    header: "Imagen",
    cell: (props) => {
      const imageUrl = props.row.original.images?.[props.row.original.mainImage] || props.row.original.images?.[0];
      const fullUrl = `${API_BASE_URL}/product/get/file/${imageUrl}`;
      return imageUrl ? (
        <img
          src={fullUrl}
          alt="Producto"
          width={60}
          height={60}
          style={{ objectFit: "cover", borderRadius: "8px" }}
        />
      ) : (
        <span>Sin imagen</span>
      );
    },
  }),

  columnHelper.accessor("title", {
    header: "Título",
  }),

  columnHelper.display({
    id: "countries_prices",
    header: "Países / Precios",
    cell: (props) => {
      const adData = props.row.original.aditionalData || [];
      if (adData.length === 0) return <span>Sin países</span>;

      return (
        <div className="d-flex flex-column gap-1">
          {adData.map((item, idx) => (
            <Badge key={idx} color="light" pill>
              {item.country_id?.name ?? "País desconocido"} - ${item.price_local_currency.toLocaleString()}
            </Badge>
          ))}
        </div>
      );
    },
  }),

  columnHelper.display({
    id: "avg_usdt",
    header: "Prom. USDT",
    cell: (props) => {
      const adData = props.row.original.aditionalData || [];
      if (adData.length === 0) return "-";

      const avg = adData.reduce((sum, item) => sum + (item.price_usdt ?? 0), 0) / adData.length;
      return `${avg.toFixed(2)} USDT`;
    },
  }),

  columnHelper.display({
    id: "short_desc",
    header: "Descripción corta",
    cell: (props) => {
      const text = props.row.original.shortDescription;
      const id = `desc-tooltip-${props.row.index}`;

      if (text?.length > 20) {
        return (
          <>
            <span id={id}>{text.substring(0, 20)}...</span>
            <UncontrolledTooltip placement="top" target={id}>
              {text}
            </UncontrolledTooltip>
          </>
        );
      }

      return <span>{text}</span>;
    },
  }),

  columnHelper.display({
    id: "status",
    header: "Estado",
    cell: (props) => {
      const status = props.row.original.status;
      const color = status ? "success" : "danger";
      return <Badge color={color}>{status ? "Activo" : "Inactivo"}</Badge>;
    },
  }),

  columnHelper.accessor("created_at", {
    header: "Fecha creación",
    cell: (info) => new Date(info.getValue()).toLocaleDateString(),
  }),

  columnHelper.display({
    id: "actions",
    header: "Acciones",
    cell: (props) => {
      const product = props.row.original;
      const isActive = product.status;
      const toggleColor = isActive ? "danger" : "success";
      const toggleIcon = isActive ? "fa fa-toggle-off" : "fa fa-toggle-on";
      const toggleText = isActive ? "Inactivar" : "Activar";

      const editId = `edit-btn-${product.id}`;
      const toggleId = `toggle-btn-${product.id}`;
      const detailId = `detail-btn-${product.id}`;

      return (
        <div className="d-flex gap-2">
          <Btn
            attrBtn={{ color: "light", size: "sm", id: detailId, onClick: () => navigate(`/product/detail/${product.id}`) }}
          >
            <i className="fa fa-eye" />
          </Btn>
          <UncontrolledTooltip target={detailId}>Ver detalle</UncontrolledTooltip>

          <Btn
            attrBtn={{
              color: "primary",
              size: "sm",
              id: editId,
              onClick: () => navigate(`/product/edit/${product.id}`),
              disabled: role === "ASSISTANT"
            }}
          >
            <i className="fa fa-edit" />
          </Btn>
          <UncontrolledTooltip target={editId}>Editar</UncontrolledTooltip>

          <Btn
            attrBtn={{
              color: toggleColor,
              size: "sm",
              id: toggleId,
              onClick: () => handleToggleStatus(product),
              disabled: role === "ASSISTANT"
            }}
          >
            <i className={toggleIcon} />
          </Btn>
          <UncontrolledTooltip target={toggleId}>{toggleText}</UncontrolledTooltip>
        </div>
      );
    },
  }),
];
